import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
  replayContainer: {
    border: "1px solid rgba(224, 224, 224, 1)",
    borderRadius: theme.spacing(1),
    padding: theme.spacing(1),
    flexGrow: 1,
    width: "70%",
    marginRight: "10px",
  },
  replayBody: {
    display: "flex",
    alignSelf: "flex-start",
    maxWidth: "600px",
    marginBottom: theme.spacing(1),
    border: "1px solid rgba(224, 224, 224, 1)",
    borderRadius: theme.spacing(1),
    padding: theme.spacing(1),
    position: "relative",
  },
  replayText: { marginLeft: "15px", flexGrow: 1 },
  input: {
    color: theme.palette.contrastText.main,
    border: "none",
    outline: "none",
    padding: 0,
    "& fieldset": {
      backgroundColor: theme.palette.separator.main,
    },
  },
  attachIconBtn: {
    margin: 4,
    padding: 0,
  },
  attachIcon: {
    margin: 0,
    padding: 0,
    fill: theme.palette.contrastIcon.main,
  },
  send: {
    height: "48px",
    marginLeft: "8px",
    background: theme.palette.primary.main,
  },
  marker: {
    display: "inline",
    height: "18px",
    width: "2px",
    backgroundColor: theme.palette.primary.main,
    position: "absolute",
    left: "10px",
  },
  sendError: {
    border: "1px solid rgba(244, 67, 54, 1)",
  },
}));
